//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
import { FactoryUtils } from "@/utils/FactoryUtils"    
import claim  from '@/components/layer/claim.vue'
export default {
    name: "claims",
    data(){
        return {
            claimsText:{},
            scroll:"",
            claimsFlag:false,
            wrapperChildLenght:'',
            templateFlag:'tk_irok'
        }
    },
    components:{
        claim
    },
    created(){
      FactoryUtils.claimsText().then(res =>{
        this.claimsText = res;
        if(res.claimsFlag){
            this.claimsFlag = res.claimsFlag
        }
      })
    },
    props: {
        claims: {
            type: Array,
            default() { return []}
        },
        qybFlag: {
            type: Boolean,
            default() { return true}
        },
        claimsShow: {    //是否展示就诊说明
            type: Boolean,
            default() { return true}
        },
    },
    mounted(){
        console.log(':class=',this.claims.length)
        if(this.qybFlag){
            this.scrollInit()
        }
        let msg = this.$refs.listbox.offsetTop;
        this.$emit('func',msg)
        if(this.$route.query.templateFlag){
            this.templateFlag = this.$route.query.templateFlag;
        }
    },
    methods:{
        moreComment(){ //理赔查看详情
                this.STATISTICS('click','sybao_ins_proinfo_claimdetail_click')
              
                this.$refs.claimsRef.showToast();
            
            
        },
        suggests(){
            this.$router.push({
                path: "/suggestsTest",
                query:{
                  templateFlag:this.templateFlag
                }
            });
        },
        // 热门滚动
        scrollInit(){
            let personWidth = 0,wrapperChild = this.$refs.wrapperChild;
            this.wrapperChildLenght =  wrapperChild.children.length-1;
            if(wrapperChild.children.length>1){
                this.scroll  = new BScroll(this.$refs.wrapper, {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    scrollY: false,
                    eventPassthrough: "vertical"
                });
                for (let i = 0; i < wrapperChild.children.length; i++) {
                    personWidth += wrapperChild.children[i].clientWidth 
                }
                personWidth += (wrapperChild.children.length-1) * 15 + 15
            }else{
               personWidth =  250;
            }
            this.$refs.wrapperChild.style.width = personWidth+ "px";
        }
    }
}
